export default "__VITE_ASSET__BGwuoAAJ__"